/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Row,
} from 'react-bootstrap';
import ControlTips from 'loracoms/ControlTips';
import registerActions from 'loraactions/register';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { callAPI } from 'lorautils/api';
import Checkbox from 'loracoms/Checkbox';
import RichButton from 'loracoms/RichButton';
import ShowIf from 'loracoms/ShowIf';
import FormBlock from 'loracoms/FormBlock';
import RegisterResult from './coms/RegisterResult';
import PwdStrengthMeter from './coms/PwdStrengthMeter';
import Captcha from './coms/Captcha';
import styles from './styles.scss';


const kLabelCols = 3;
const kControlCols = 6;
const kExtraCols = 3;
const kEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  loadCaptcha: React.PropTypes.func.isRequired,
  captchaState: React.PropTypes.object.isRequired,
  checkEmail: React.PropTypes.func.isRequired,
  emailState: React.PropTypes.object.isRequired,
  resetCheckEmail: React.PropTypes.func.isRequired,
};

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      registerOk: false,
      errors: (
        ErrorSet.createEmpty()
          .add('FE_EMPTY', 'email')
          .add('FE_EMPTY', 'password')
          .add('FE_EMPTY', 'name')
          .add('FE_EMPTY', 'tel')
          .add('FE_EMPTY', 'company')
          .add('FE_EMPTY', 'captcha')
      ),
      captchaState: props.captchaState,
      emailState: props.emailState,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleCheckEmail = this.handleCheckEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeTel = this.handleChangeTel.bind(this);
    this.handleChangeCompany = this.handleChangeCompany.bind(this);
    this.handleChangeVerifyCode = this.handleChangeVerifyCode.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'register');
  }

  componentWillReceiveProps(nextProps) {
    const { captchaState, emailState } = nextProps;
    if (captchaState !== this.props.captchaState) {
      this.setState({ captchaState });
    }
    if (emailState !== this.props.emailState) {
      this.setState({ emailState });
    }
  }

  componentWillUnmount() {
    const { resetCheckEmail } = this.props;
    resetCheckEmail();
  }

  handleChangeEmail(e) {
    const email = e.target.value;
    this.setState({ email });

    const { errors } = this.state;
    if (email.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'email') });
    } else if (!kEmailRegex.test(email)) {
      this.setState({ errors: errors.add('FE_INVALIDEMAIL', 'email') });
    } else {
      this.setState({ errors: errors.remove('email') });
    }
  }

  handleCheckEmail() {
    const { checkEmail } = this.props;
    const { errors, email } = this.state;
    if (!errors.has('email')) {
      checkEmail(email);
    }
  }

  handleChangePassword(e) {
    const password = e.target.value;
    this.setState({ password });

    const { errors } = this.state;
    if (password.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'password') });
    } else if (password.length < 6 || password.length > 16) {
      this.setState({ errors: errors.add('FE_PASSWORDINVALIDLEN', 'password') });
    } else {
      this.setState({ errors: errors.remove('password') });
    }
  }

  handleChangeName(e) {
    const name = e.target.value;
    this.setState({ name });

    const { errors } = this.state;
    if (name.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
  }

  handleChangeTel(e) {
    const tel = e.target.value;
    this.setState({ tel });

    const { errors } = this.state;
    if (tel.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'tel') });
    } else {
      this.setState({ errors: errors.remove('tel') });
    }
  }

  handleChangeCompany(e) {
    const company = e.target.value;
    this.setState({ company });

    const { errors } = this.state;
    if (company.trim() === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'company') });
    } else {
      this.setState({ errors: errors.remove('company') });
    }
  }

  handleChangeVerifyCode(e) {
    const verifyCode = e.target.value;
    this.setState({ verifyCode });

    const { errors } = this.state;
    if (verifyCode.trim() === '') {
      this.setSTate({ errors: errors.add('FE_EMPTY', 'captcha') });
    } else {
      this.setState({ errors: errors.remove('captcha') });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });

    let { errors } = this.state;
    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    const { loadCaptcha } = this.props;
    const {
      captchaState: { data: { key } = {} },
      email,
      password,
      name,
      tel,
      company,
      verifyCode,
    } = this.state;

    callAPI({
      endpoint: '/account/regist',
      method: 'POST',
      body: {
        key,
        email,
        password,
        name,
        tel,
        company,
        verifyCode,
        ref: 'lora',
      },
    }).then((resp) => {
      this.setState({
        registerStatus: resp.status,
      });
      if (resp.status === 'apply' || resp.status === 'accepted') {
        this.setState({
          registerOk: true,
        });
      }
    }).catch((error) => {
      this.setState({
        errors: errors.add(error.code, 'submit'),
      });
      if (error.code === 'BADVERIFY') {
        loadCaptcha();
      }
    });
  }

  render() {
    const {
      registerOk,
      registerStatus = '',
      status = '',
      email = '',
      name = '',
      password = '',
      tel = '',
      company = '',
      verifyCode = '',
      agree = false,
      errors,
      submitted = false,
      emailState = {},
    } = this.state;

    if (registerOk) {
      return (
        <div className={styles.register} style={{ minHeight: window.innerHeight }}>
          <RegisterResult
            status={registerStatus}
            email={email}
            goBack={() => this.setState({ registerOk: false })}
          />
        </div>
      );
    }

    return (
      <div className={styles.register} style={{ minHeight: window.innerHeight }}>
        <div className={styles.form}>
          <h1>{this.intlMsg.msg('title')}</h1>
          <Form horizontal onSubmit={this.handleSubmit}>
            <FormGroup validationState={submitted && errors.has('email') ? 'error' : undefined}>
              <Col md={kLabelCols}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('email')}
                </ControlLabel>
              </Col>
              <Col md={kControlCols}>
                <FormControl
                  bsClass="aisz-form-control-f"
                  type="email"
                  value={email}
                  placeholder={this.intlMsg.msg('email.placeholder')}
                  onChange={this.handleChangeEmail}
                  onBlur={this.handleCheckEmail}
                />
                <ControlTips
                  show={submitted && errors.has('email')}
                  message={this.intlMsg.errorMsg(errors.get('email'))}
                  azStyle="danger"
                />
              </Col>
              <Col md={kExtraCols} className="collapse-left">
                <ShowIf if={emailState.status === 'pending'}>
                  <span className={styles.emailCheck}>
                    <i className="fa fa-spinner fa-spin" />
                  </span>
                </ShowIf>
                <ShowIf if={emailState.status === 'success'}>
                  <span className={`${styles.emailCheck} text-success`}>
                    <i className="fa fa-check-circle" />
                  </span>
                </ShowIf>
                <ShowIf if={emailState.status === 'failure'}>
                  <span className={`${styles.emailCheck} text-danger`}>
                    <i className="fa fa-exclamation-triangle" />{' '}
                    {emailState.error && this.intlMsg.errorMsg(emailState.error.code)}
                  </span>
                </ShowIf>
              </Col>
            </FormGroup>
            <FormGroup validationState={submitted && errors.has('password') ? 'error' : undefined}>
              <Col md={kLabelCols}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('password')}
                </ControlLabel>
              </Col>
              <Col md={kControlCols}>
                <FormControl
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('password.placeholder')}
                  type="password"
                  value={password}
                  onChange={this.handleChangePassword}
                />
                <ControlTips
                  show={submitted && errors.has('password')}
                  message={this.intlMsg.errorMsg(errors.get('password'))}
                  azStyle="danger"
                />
                <PwdStrengthMeter password={password} />
              </Col>
            </FormGroup>
            <FormGroup validationState={submitted && errors.has('name') ? 'error' : undefined}>
              <Col md={kLabelCols}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('name')}
                </ControlLabel>
              </Col>
              <Col md={kControlCols}>
                <FormControl
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('name.placeholder')}
                  value={name}
                  onChange={this.handleChangeName}
                />
                <ControlTips
                  show={submitted && errors.has('name')}
                  message={this.intlMsg.errorMsg(errors.get('name'))}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup validationState={submitted && errors.has('tel') ? 'error' : undefined}>
              <Col md={kLabelCols}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('tele')}
                </ControlLabel>
              </Col>
              <Col md={kControlCols}>
                <FormControl
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('tele.placeholder')}
                  value={tel}
                  onChange={this.handleChangeTel}
                />
                <ControlTips
                  show={submitted && errors.has('tel')}
                  message={this.intlMsg.errorMsg(errors.get('tel'))}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup validationState={submitted && errors.has('company') ? 'error' : undefined}>
              <Col md={kLabelCols}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('company')}
                </ControlLabel>
              </Col>
              <Col md={kControlCols}>
                <FormControl
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('company.placeholder')}
                  value={company}
                  onChange={this.handleChangeCompany}
                />
                <ControlTips
                  show={submitted && errors.has('company')}
                  message={this.intlMsg.errorMsg(errors.get('company'))}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup validationState={submitted && errors.has('captcha') ? 'error' : undefined}>
              <Col md={kLabelCols}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('captcha')}
                </ControlLabel>
              </Col>
              <Col md={kControlCols}>
                <Row>
                  <Col md={6}>
                    <FormControl
                      bsClass="aisz-form-control-f"
                      value={verifyCode}
                      onChange={this.handleChangeVerifyCode}
                    />
                  </Col>
                  <Col md={6}>
                    <Captcha />
                  </Col>
                </Row>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={9} mdOffset={3}>
                <Checkbox
                  id="agree"
                  checked={agree}
                  onChange={() => this.setState({ agree: !agree })}
                />
                {' '}
                <span className={styles.agree}>
                  {this.intlMsg.msg('agree')}{' '}
                  <Link onClick={() => window.open('/public/serviceAgreement')}>
                    {this.intlMsg.msg('policy')}
                  </Link>
                </span>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={kControlCols} mdOffset={kLabelCols} className={styles.submit}>
                <RichButton
                  status={status}
                  states={[{
                    status: 'default',
                    type: 'submit',
                    style: 'primary',
                    label: (
                      <span>
                        <i className="fa fa-user-plus" />{' '}
                        {this.intlMsg.msg('submit')}
                      </span>
                    ),
                    disabled: !agree,
                  }, {
                    status: 'pending',
                    style: 'primary',
                    label: (
                      <span>
                        <i className="fa fa-spin fa-spinner" />{' '}
                        {this.intlMsg.msg('submit.pending')}
                      </span>
                    ),
                  }, {
                    status: 'failure',
                    style: 'danger',
                    label: (
                      <span>
                        <i className="fa fa-exclamation-triangle" />{' '}
                        {this.intlMsg.msg('submit.failure')}
                      </span>
                    ),
                  }]}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={kControlCols} mdOffset={kLabelCols}>
                <FormBlock
                  show={errors.has('submit')}
                  message={this.intlMsg.errorMsg(errors.get('submit'))}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
          </Form>
        </div>
      </div>
    );
  }
}


Register.propTypes = propTypes;


const mapStateToProps = state => ({
  captchaState: state.register.captcha,
  emailState: state.register.checkEmail,
});

const mapDispatchToProps = {
  loadCaptcha: registerActions.captcha,
  checkEmail: registerActions.checkEmail,
  resetCheckEmail: registerActions.resetCheckEmail,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Register, styles));




// WEBPACK FOOTER //
// ./src/containers/Register/index.jsx